module.exports = __webpack_public_path__ + "static/img/Bachelor_010825.3e35665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010825.jpg
// module id = 257
// module chunks = 0